// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').factory('startPageTrackingService', [
  '$document',
  '$window',
  function ($document, $window) {
    const sendEvent = (eventName, eventId) =>
      $document.ready(function () {
        $window.pageTrackingVariables = Object.keys(
          $.siteCatalyst.pageTrackingVariables()
        ).join(',');
        return;
      });

    return { sendEvent };
  },
]);
